import { HttpClient } from './http-client';

export class VzdService extends HttpClient {
  searchAddress(search: string) {
    return this.get(`/api/services/vzd/search/${search}`);
  }
}
